import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import NewsletterSubscribeFeedback from '../../../shared/NewsletterSubscribeFeedback/NewsletterSubscribeFeedback';
import { useMarketAnalysisMarketInsightsContent } from '../../../../hooks/useMarketAnalysisMarketInsightsContent';
import { useNewsletterSubscribe } from '../../../../hooks/useNewsletterSubscribe';
import { NEWSLETTER_SOURCES } from '../../../../utils/newsletterSources';
import '../../../shared/NewsletterSubscribeFeedback/NewsletterSubscribeFeedback.css';
import './MarketInsights.css';

const MarketInsights = () => {
  const { content, isLoading } = useMarketAnalysisMarketInsightsContent();
  const {
    email,
    setEmail,
    isSubmitting,
    isSuccess,
    formError,
    fieldError,
    handleSubmit,
  } = useNewsletterSubscribe(NEWSLETTER_SOURCES.MARKET_ANALYSIS);

  if (isLoading || !content) {
    return null;
  }

  const { title, text, buttonText, privacy } = content;

  return (
    <section className="market-insights">
      <div className="market-insights__inner">
        <Reveal className="market-insights__panel">
          <div className="market-insights__copy">
            <h2 className="market-insights__title">{title}</h2>
            {text ? <p className="market-insights__text">{text}</p> : null}
          </div>

          <form
            className="market-insights__form"
            onSubmit={handleSubmit}
            noValidate
          >
            <div className="market-insights__row">
              <label className="market-insights__field">
                <span className="market-insights__sr-only">Email address</span>
                <input
                  className={`market-insights__input${
                    fieldError ? ' newsletter-subscribe-input--error' : ''
                  }`}
                  type="email"
                  name="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="Enter your email"
                  autoComplete="email"
                  disabled={isSubmitting}
                />
              </label>
              <button
                type="submit"
                className="market-insights__button luxury-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Subscribing…' : buttonText}
              </button>
            </div>

            <NewsletterSubscribeFeedback
              formError={formError}
              fieldError={fieldError}
              isSuccess={isSuccess}
            />

            {privacy?.text ? (
              <p className="market-insights__privacy">
                {privacy.text}{' '}
                <Link to={privacy.linkUrl} className="market-insights__privacy-link">
                  {privacy.linkText}
                </Link>
              </p>
            ) : null}
          </form>
        </Reveal>
      </div>
    </section>
  );
};

export default MarketInsights;
